import Button from '@atlaskit/button/new';
import { IButton } from './button-interface';

const SharedButton = ({
  isLoading = false,
  onClick,
  fitContainer = false,
  type,
  appearance,
  label,
  spacing,
  disabled = false,
  icon,
  ref,
  testId,
}: IButton) => (
  <Button
    isLoading={isLoading}
    onClick={onClick}
    shouldFitContainer={fitContainer}
    type={type}
    appearance={appearance}
    spacing={spacing}
    isDisabled={disabled}
    iconBefore={icon}
    ref={ref}
    testId={testId}
  >
    {label}
  </Button>
);

export default SharedButton;
